import { render, staticRenderFns } from "./Notify.vue?vue&type=template&id=0ffc0fe8&"
import script from "./Notify.vue?vue&type=script&lang=ts&"
export * from "./Notify.vue?vue&type=script&lang=ts&"
import style0 from "./Notify.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports